import { SelectItem, SelectItemGroup } from 'primeng/api';

/**
 * Grouped school location. It is used to display the school locations inside
 * the location selector grouped by country.
 */
export type GroupedSchoolLocation = SelectItemGroup & { weight?: number; items: SelectItemSchoolLocation[] };

type SelectItemSchoolLocation = SelectItem & { weight?: number };
